<template>
    <section>
        <fixed-header title="Commissions List" hideNewOfferBtn />
        <div class="card">
            <div class="card-body" name="card body">
                <b-tabs lazy>
                    <b-tab title="Unpaid Commission">
                        <template v-slot:title>
                            Unpaid Commissions 
                        </template>
                        <b-tabs lazy>
                            <b-tab title="Sales">
                                <grid
                                    :gridId="salesGridId"
                                    :pageInfo="salesPageInfo"
                                    :itemData="unPaidSalesCommission"
                                    :fields="salesFields"
                                    :handleRowClick="handleRowClick"
                                    :onDelete="onDeleteCommission"
                                />
                            </b-tab>
                            <b-tab title="Purchases">
                                <grid
                                    :gridId="purchaseGridId"
                                    :pageInfo="purchasePageInfo"
                                    :itemData="unPaidPurchaseCommission"
                                    :fields="purchasesFields"
                                    :handleRowClick="handleRowClick"
                                    :onDelete="onDeleteCommission"
                                />
                            </b-tab>
                        </b-tabs>
                    </b-tab>
                    <b-tab title="Paid Commissions">
                        <b-tabs lazy>
                            <b-tab title="Sales">
                                <grid
                                    :gridId="salesGridId"
                                    :pageInfo="salesPageInfo"
                                    :itemData="paidSalesCommission"
                                    :fields="salesFields"
                                    :handleRowClick="handleRowClick"
                                    :onDelete="onDeleteCommission"
                                />
                            </b-tab>
                            <b-tab title="Purchases">
                                <grid
                                    :gridId="purchaseGridId"
                                    :pageInfo="purchasePageInfo"
                                    :itemData="paidPurchaseCommission"
                                    :fields="purchasesFields"
                                    :handleRowClick="handleRowClick"
                                    :onDelete="onDeleteCommission"
                                />
                            </b-tab>
                        </b-tabs>
                    </b-tab>
                </b-tabs>
            </div>
        </div>

        <b-modal :title="modalDetailsTitle" id="line-modal" size="xl" ok-only>
            <div>
                <b-row class="mb-2">
                    <b-col cols="1">
                        <dt>Rep</dt>
                        <dd>{{ infoDetails.userFullName }}</dd>
                    </b-col>
                    <b-col cols="2">
                        <dt>Commission Date</dt>
                        <dd>{{ date(infoDetails.commissionDate) }}</dd>
                    </b-col>
                    <b-col cols="2">
                        <dt>Total Commission Amount</dt>
                        <dd>{{ commafy(infoDetails.amount) }}</dd>
                    </b-col>
                    <b-col cols="1">
                        <dt>Status</dt>
                        <dd>{{ infoDetails.isPaid ? 'PAID' : 'UNPAID' }}</dd>
                    </b-col>
                </b-row>
                <b-button size="sm" class="mb-2" variant="primary" v-b-modal:spif-modal>Add SPIF</b-button>
                <b-modal size="sm" id="spif-modal" ref="spif-modal" ok-title="Add" @ok="onAddingSPIF" @show="spifInfo = {}" title="Add SPIF">
                    <b-form-group label="Amount">
                        <b-form-input type="number" v-model="spifInfo.amount"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Comment">
                        <b-textarea v-model="spifInfo.comment" rows="3"></b-textarea>
                    </b-form-group>                    
                </b-modal>
                <b-row class="mb-2">
                    <b-col v-if="infoItems.length > 0">
                        <vue-good-table
                            compactMode
                            fixedHeader
                            ref="SimpleTable"
                            :columns="infoField"
                            :rows="infoItems"
                            styleClass="vgt-table condensed vgt-table fixed-header"
                        >
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.cell == 'formatMoney'">
                                {{ commafy(props.row[props.column.field]) }}
                            </span>
                            <span v-else-if="props.column.cell == 'formatPrice'">
                                {{ commafy(props.row[props.column.field], 4) }}
                            </span>
                            <span v-else-if="props.column.cell == 'formatPercentage'">
                                {{ props.row[props.column.field] }}%
                            </span>
                            <span v-else-if="props.column.cell == 'viewPurchaseBtn'">
                                <b-button size="sm" variant="warning" @click="onGettingPurchaseInfo(props.row[props.column.field])" :disabled="props.row.commissionTypeId == commissionSpifId">
                                    Purchases
                                </b-button>                                
                            </span>
                            <span v-else-if="props.column.cell == 'viewSalesBtn'">
                                <b-button size="sm" variant="warning" @click="onGettingSalesInfo(props.row[props.column.field])">
                                    Sales
                                </b-button>
                            </span>
                            <span v-else-if="props.column.cell == 'popUpCommentFieldBtn'">
                                <b-button size="sm" variant="info" @click="onCreateComment(props.row)">
                                    Comment
                                </b-button>
                                <b-modal
                                    size="lg"
                                    :id="'comment-line-modal-'+props.row.id"
                                    :ref="'comment-line-modal-'+props.row.id"
                                    ok-title="Save"
                                    @ok="onSaveComment">
                                    <template slot="modal-header">
                                        <h5 class="modal-title">Comment
                                        </h5>
                                    </template>
                                    <b-textarea v-model="commentInfo.comment" rows="3"></b-textarea>
                                </b-modal>
                            </span>
                            <span v-else-if="props.column.cell == 'deleteBtn'">
                                <b-button size="sm" variant="danger" @click="onRemoveLine(props.row)">
                                    Remove
                                </b-button>
                            </span>
                            <span v-else-if="props.column.cell == 'formatLink'">
                                <span v-if="props.column.route != ''">
                                    <a class="report-link" @click="navigateLink(props.column.route, props.row[props.column.field])">{{ props.row[props.column.field] }}</a>
                                </span>
                                <span v-else>
                                {{ props.row[props.column.field] }}
                                </span>
                            </span>
                            <span v-else>
                                {{ props.row[props.column.field] }}
                            </span>
                        </template>
                        </vue-good-table>
                    </b-col>
                    <b-col v-else>
                        <h3><center>No items in here</center></h3>
                    </b-col>
                </b-row>
                <b-button variant="success" v-b-modal:commission-paid-modal>Mark as Paid</b-button>
                
            </div>
            <template slot="modal-footer">
                <b-button variant="success" :disabled="isExporting" @click="onExport" class="mr-auto"> Export</b-button>
                <b-button variant="primary" @click="onModalClose">OK</b-button>
            </template>
        </b-modal>

        <b-modal :title="modalPurchasesTitle" id="purchases-modal-info" size="xl" ok-only>
            <b-row>
                <b-col>
                <vgt-grid :fields="actionInfoField" :items="actionInfoItems" />
                </b-col>
            </b-row>
        </b-modal>

        <b-modal size="lg" id="commission-paid-modal" ref="commission-paid-modal" title="Commission Paid" @ok="onCommissionPaid">
            <h6>Enter payment details</h6>
            <b-row>
                <b-col>
                    <b-form-group label="Date Paid">
                        <date-picker v-model="paymentObj.paymentDate" :config="datePickerOptions"></date-picker>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="Payment Method">
                        <b-form-select v-model="paymentObj.paymentMethodId">
                            <option v-for="method in sortSelect(paymentMethods)" :key="method.id" :value="method.id">
                                {{method.name}}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Reference Number">
                        <b-form-input v-model="paymentObj.referenceNumber"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="Memo">
                        <b-form-input v-model="paymentObj.comments"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>
    </section>   
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import { GRID_ID, DATE_FORMAT } from '@/shared/constants';
import { date } from '@/shared/filters';
import Grid from './grid';
import VgtGrid from './vgt-grid';
import { 
    SALES_COMMISSION_LIST_FIELDS, 
    SALES_COMMISSION_LINES_FIELDS,
    PURCHASE_INFO_FIELDS,
    PURCHASE_COMMISSION_LIST_FIELDS, 
    PURCHASE_COMMISSION_LINES_FIELDS,
    SALES_INFO_FIELDS } from './fields';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';

export default {
    components: {
        FixedHeader,
        Grid,
        VueGoodTable,
        VgtGrid
    },
    data() {
        return {
            date,
            tabIndex: 0,
            unPaidSalesList: [],
            unPaidPurchasesList: [],
            salesFields: SALES_COMMISSION_LIST_FIELDS,
            salesLineFields: SALES_COMMISSION_LINES_FIELDS,
            salesGridId: GRID_ID.SALES_COMMISSION_GRID,
            purchasesFields: PURCHASE_COMMISSION_LIST_FIELDS,
            purchasesLineFields: PURCHASE_COMMISSION_LINES_FIELDS,
            purchaseGridId: GRID_ID.PURCHASE_COMMISSION_GRID,
            PURCHASE_INFO_FIELDS,
            SALES_INFO_FIELDS,
            infoDetails: {},
            infoField: [],
            infoItems: [],
            commentInfo: {},
            actionInfoField: [],
            actionInfoItems: [],
            modalDetailsTitle: 'Lines',
            modalPurchasesTitle: 'Purchases',
            spifInfo: {},
            commissionSpifId: 1563,
            paymentObj: {},
            datePickerOptions: {
                format: DATE_FORMAT,
                useCurrent: false,
            },
            isExporting: false
        };
    },
    computed: {
        ...mapState('commission', ['salesList', 'purchasesList']),
        ...mapGetters('commission', ['salesPageInfo', 'purchasePageInfo']),
        ...mapGetters('lookup', ['paymentMethods']),
        unPaidSalesCommission() {
            return this.salesList.filter(x => !x.isPaid);
        },
        paidSalesCommission() {
            return this.salesList.filter(x => x.isPaid);
        },
        unPaidPurchaseCommission() {
            return this.purchasesList.filter(x => !x.isPaid);
        },
        paidPurchaseCommission() {
            return this.purchasesList.filter(x => x.isPaid);
        }
    },
    methods: {
        ...mapActions('commission', ['getAllSales', 'getAllPurchases', 'updateCommission', 'deleteCommission',
        'getCommissionLines', 'patchCommissionLine', 'deleteCommissionLine', 'postCommissionLine', 'exportCommission']),
        ...mapActions('reports', ['getPurchaseInfo', 'getSalesInfo']),
        handleRowClick({ dataItem }) {
            this.getCommissionLines(dataItem.id).then((res) =>  {
                this.infoDetails = dataItem;
                this.infoItems = res;
                this.modalDetailsTitle = `Commission for ${dataItem.userFullName}`
                if (res.length > 0) {
                    let firstResult = res[0]
                    this.infoField = firstResult.commissionTypeId == 1561 || firstResult.commissionTypeId == 1564 ? this.salesLineFields : this.purchasesLineFields;
                }
                this.$bvModal.show('line-modal');
            })
        },
        async onDeleteCommission(item) {
            const response = await this.openConfirmBox({ message: `Are you sure you want to remove this commission?` });
            if (response) {
                this.deleteCommission(item.id).then((res) => {
                    if (res.status == 200) {
                        let i = this.salesList.findIndex(x => x.id == item.id);
                        if (i > -1) {
                            this.salesList.splice(i,1);
                        }                        

                        this.$snotify.success('Successfully deleted commission');
                    }
                })     
            }
        },
        onGettingPurchaseInfo(id) {
            this.getPurchaseInfo(id).then((res) => {
                this.actionInfoField = this.PURCHASE_INFO_FIELDS;
                this.actionInfoItems = res;
                this.modalTitle = `Purchases for Invoice ${id}`;
                this.$bvModal.show('purchases-modal-info');
            })
        },
        onGettingSalesInfo(id) {
            this.getSalesInfo(id).then((res) => {
                this.actionInfoField = this.SALES_INFO_FIELDS;
                this.actionInfoItems = res;
                this.modalTitle = `Sales for PO ${id}`;
                this.$bvModal.show('modal-info');
            })
        },
        commafy(num, decimal = 2) {
            try {
                if (num != null) {
                var str = num.toString().split('.');
                if (str[0].length >= 3) {
                    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
                }
                if (str[1]) {
                    if (str[1].length < decimal) {
                    while (str[1].length < decimal) { str[1] = str[1] + "0"; }
                    } else if (str[1].length > decimal) {
                    str[1] = str[1].substring(0, decimal)
                    }
                }
                return str.join('.');
                }
            } catch {
                return num;
            }
        },
        onCreateComment(row) {
            this.commentInfo = {
                id: row.id,
                comment: row.comment
            },
            this.$bvModal.show(`comment-line-modal-${row.id}`);
        },
        onSaveComment() {
            this.patchCommissionLine({
                id: this.commentInfo.id,
                patch: [{ 'op': 'replace', 'path': '/comment', 'value': this.commentInfo.comment }]
            }).then((res) => {
                if (res.status == 200) {
                    let i = this.infoItems.findIndex(x => x.id == this.commentInfo.id);

                    if (i > -1) {
                        this.infoItems[i].comment = this.commentInfo.comment;
                    }
                    this.$snotify.success('Successfully saved comment.');
                    
                }
            })
        },
        async onRemoveLine(line) {
            const response = await this.openConfirmBox({ message: `Are you sure you want to remove line?` });
            if (response) {
                this.deleteCommissionLine(line.id).then((res) => {
                    if (res.status == 200) {
                        let i = this.infoItems.findIndex(x => x.id == line.id);
                        if (i > -1) {
                            this.infoItems.splice(i,1);
                        }
                        this.updateCommissionAmount(line.commissionId, line.amount * -1);
                        

                        this.$snotify.success('Successfully removed line');
                    }
                })     
            }
        },
        updateCommissionAmount(commissionId, amount) {
            let j = this.salesList.findIndex(x => x.id == commissionId);
            if (j > -1) {
                this.salesList[j].amount = Number(this.salesList[j].amount) + Number(amount);

                if (this.infoItems != null && this.infoItems.id == commissionId) {
                    this.infoItems.amount = Number(this.infoItems.amount) + Number(amount);
                }
            }
        },     
        onAddingSPIF() {
            if (Object.keys(this.infoDetails).length > 0 && Object.keys(this.spifInfo).length > 0) {
                this.postCommissionLine({
                    ...this.spifInfo,
                    commissionTypeId: this.commissionSpifId,
                    commissionId: this.infoDetails.id
                }).then((res) => {
                    if (res.status == 200) {
                        this.updateCommissionAmount(this.infoDetails.id, this.spifInfo.amount);
                        this.infoItems.push(res.data);
                        this.$snotify.success('Successfully added SPIF');
                    }
                })    
            }
            
        },
        navigateLink(route, value) {
            let routeData = this.$router.resolve({ name: route, params: {id: value} })
            window.open(routeData.href, '_blank');
        },
        async onCommissionPaid() {
            await this.updateCommission({
            id: this.infoDetails.id,
            commission: {
                ...this.infoDetails,
                isPaid: true,
                paymentMethodId: this.paymentObj.paymentMethodId || 0,
                paymentDate: this.paymentObj.paymentDate || null,
                referenceNumber: this.paymentObj.referenceNumber || null,
                comment: this.paymentObj.memo || null
            }}).then((res) => {
                if (res.status == 200) {
                    this.infoDetails = null;
                    this.getAllSales({});
                    this.getAllPurchases({});
                    this.$bvModal.hide('line-modal');
                }
            })
        },
        async onExport() {
            this.isExporting = true;
            await this.exportCommission([this.infoDetails.id]).then((res) => {
              this.isExporting = false;
              this.$snotify.success('Successfully exported');
            });  
        },
        onModalClose() {
            this.infoDetails = {};
            this.infoItems = {};
            this.modalDetailsTitle = `Sales Commission`
            this.infoField = [];
            this.$bvModal.hide('line-modal');
        }
    },
    mounted() {
        this.getAllSales({});
        this.getAllPurchases({});
    }
}
</script>